import { createContext, useContext } from 'react';

/** The parent area stays unlocked for a short time, in memory only (a reload locks it). */
export const PARENT_SESSION_MS = 15 * 60_000;

export interface ParentSession {
  unlocked: boolean;
  unlock: () => void;
  lock: () => void;
}

export const ParentSessionContext = createContext<ParentSession | null>(null);

export function useParentSession(): ParentSession {
  const context = useContext(ParentSessionContext);
  if (!context) throw new Error('useParentSession must be used inside <ParentSessionProvider>');
  return context;
}
